import { apiUploader } from "./base";

export function awsUploader(formdata, config = {}) {
  let api = apiUploader();
  return api.post('v1/images/aws/upload', formdata, config)
}